import { render, staticRenderFns } from "./QesAuthenticatePhone.vue?vue&type=template&id=002023da&"
import script from "./QesAuthenticatePhone.vue?vue&type=script&lang=js&"
export * from "./QesAuthenticatePhone.vue?vue&type=script&lang=js&"
import style0 from "./QesAuthenticatePhone.vue?vue&type=style&index=0&id=002023da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports